import axios from 'axios';
import { ActionTree, Module, MutationTree } from 'vuex';
import { namespace } from 'vuex-class';

import { Company } from '@/models/company.model';

import { RootState } from './index';


/**
 *
 * State
 *
 */
export type CompanyState = Company;

const makeInitialState = (): CompanyState => ({
  companyContact: {
    address1: '',
    address2: '',
    city: '',
    contact: '',
    email: '',
    fax: '',
    phone: '',
    state: '',
    zip: '',
  },
  companyId: '',
  companyName: '',
  locations: [],
});

const state = makeInitialState;


/**
 *
 * Mutations
 *
 */
const mutations: MutationTree<CompanyState> = {
  reset(state) {
    const initialState = makeInitialState();
    for (const key in initialState) {
      if (initialState.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  },

  setValues(state, value: Company) {
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        state[key] = value[key];
      }
    }
  },
};


/**
 *
 * Actions
 *
 */
export interface CompanyActions {
  fetch: () => Promise<void>;
}

const actions: ActionTree<CompanyState, RootState> = {
  async fetch(store) {
    const companyId = store.rootState.user.user.userInfo.companyId;
    const result = (await axios.get<Company>(`company?companyId=${companyId}`)).data;
    store.commit('setValues', result);
  },
};



export default {
  namespaced: true,
  actions,
  mutations,
  state,
} as Module<CompanyState, RootState>;


// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CompanyStore {
  export const Bind = namespace('company');
  export type State <TProp extends keyof CompanyState> = CompanyState[TProp];
  export type Action <TProp extends keyof CompanyActions> = CompanyActions[TProp];
}
